import React from 'react';
import { ShieldCheck, Star, Users, MapPin, Heart } from 'lucide-react';
export function HeroSection() {
  return <section className="w-full bg-cream flex flex-col items-center" data-id="element-48">
      {/* Urgency Banner */}
      <div className="w-full bg-gradient-to-r from-gold-400 to-gold-500 text-white text-center py-2 px-4 font-bold text-sm md:text-base tracking-wide shadow-sm" data-id="element-49">
        🔥 OFERTA POR TIEMPO LIMITADO · ACCESO DISPONIBLE HOY
      </div>

      <div className="max-w-4xl w-full px-4 pt-10 pb-16 flex flex-col items-center text-center" data-id="element-50">
        <h1 className="text-4xl md:text-6xl font-extrabold text-brown-800 mb-4 leading-tight" data-id="element-51">
          FREEZER INTELIGENTE
        </h1>

        <h2 className="text-xl md:text-2xl font-bold text-brown-800 mb-6 max-w-2xl bg-gold-400/20 px-4 py-2 rounded-lg inline-block" data-id="element-52">
          Todo tu mes de comidas resuelto.
        </h2>

        <img src="https://cdn.magicpatterns.com/uploads/oUJSErHXHAdXdTZha8jGGh/hf_20260329_010749_655a106a-de3d-4913-ae78-f3f5dff8f196.png" alt="Colección Freezer Inteligente" className="w-full max-w-2xl rounded-xl shadow-2xl mb-8 border-4 border-white object-cover" width="664" height="498" loading="eager" fetchPriority="high" decoding="async" data-id="element-53" />

        <p className="text-lg md:text-xl text-brown-800 font-bold mb-4 max-w-2xl" data-id="element-54">
          Cociná una vez, organizá tu freezer y dejá varios días listos sin
          volver a improvisar todos los días qué comer.
        </p>

        <p className="text-lg text-brown-600 mb-8 max-w-2xl" data-id="element-55">
          Una solución real para mujeres con poco tiempo que quieren comer
          mejor, gastar menos y dejar de vivir pensando qué cocinar.
        </p>

        <a href="#compra" className="bg-gradient-to-r from-gold-400 to-gold-500 text-white font-bold text-xl md:text-2xl py-4 px-8 rounded-full shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 w-full max-w-md text-center" data-id="element-56">
          👉 QUIERO ACCEDER AHORA
        </a>

        <div className="mt-4 text-brown-800 font-bold text-sm tracking-widest uppercase" data-id="element-57">
          🚀 ACCESO INMEDIATO
        </div>

        {/* Social Proof Badges */}
        <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-4 w-full max-w-3xl" data-id="element-58">
          <div className="flex flex-col items-center text-center p-3 bg-white rounded-lg shadow-sm border border-sage" data-id="element-59">
            <Users className="text-gold-500 mb-2" size={24} data-id="element-60" />
            <span className="text-xs font-bold text-brown-800" data-id="element-61">
              +500 mujeres ya empezaron a organizar sus comidas
            </span>
          </div>
          <div className="flex flex-col items-center text-center p-3 bg-white rounded-lg shadow-sm border border-sage" data-id="element-62">
            <Star className="text-gold-500 mb-2 fill-current" size={24} data-id="element-63" />
            <span className="text-xs font-bold text-brown-800" data-id="element-64">
              5/5 nivel de satisfacción
            </span>
          </div>
          <div className="flex flex-col items-center text-center p-3 bg-white rounded-lg shadow-sm border border-sage" data-id="element-65">
            <MapPin className="text-gold-500 mb-2" size={24} data-id="element-66" />
            <span className="text-xs font-bold text-brown-800" data-id="element-67">
              4.9/5 valoración promedio AR 🇦🇷
            </span>
          </div>
          <div className="flex flex-col items-center text-center p-3 bg-white rounded-lg shadow-sm border border-sage" data-id="element-68">
            <Heart className="text-gold-500 mb-2" size={24} data-id="element-69" />
            <span className="text-xs font-bold text-brown-800" data-id="element-70">
              Pensado para vida real
            </span>
          </div>
        </div>
      </div>
    </section>;
}